export const updateDataPrecise = (graphPreciseData) => {
  return(dispatch) => {
    dispatch({type: 'UPDATE_DATA_PRECISE', graphPreciseData: graphPreciseData})
  }
}



// WEBPACK FOOTER //
// ./src/actions/updateDataPrecise.js